import { createContext, useState } from 'react'

interface IUseWorkSafety {
  mock: string
}

export const WorkSafetyContext = createContext<IUseWorkSafety>(null)

export const WorkSafetyProvider: React.FC = ({ children }) => {
  const [mock] = useState<string>('')

  return (
    <WorkSafetyContext.Provider
      value={{
        mock
      }}
    >
      {children}
    </WorkSafetyContext.Provider>
  )
}
